// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TimesheetController from "./timesheet_controller"
application.register("timesheet", TimesheetController)

import SalariesFilterController from "./salaries_filter_controller"
application.register("salaries-filter", SalariesFilterController)

import TimesheetsFilterController from "./timesheets_filter_controller"
application.register("timesheets-filter", TimesheetsFilterController)

import MonthPickerController from "./month_picker_controller"
application.register("month-picker", MonthPickerController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import TimesheetUniqueSelectController from "./timesheet_unique_select_controller"
application.register("timesheet-unique-select", TimesheetUniqueSelectController)

import DateRangeShortcutsController from "./date_range_shortcuts_controller"
application.register("date-range-shortcuts", DateRangeShortcutsController)
